import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, Award, Shield } from "lucide-react";

const Partnerships = () => {
  const partnerships = [
    {
      name: "SAP Partner Open Ecosystem",
      description: "Certified SAP partner delivering enterprise solutions and implementation services",
      benefits: [
        "Certified SAP consultants",
        "End-to-end SAP implementation",
        "Custom SAP development",
        "SAP migration & support"
      ],
      icon: Award,
      color: "bg-blue-500",
      link: "/sap"
    },
    {
      name: "AWS Partner Network",
      description: "Official AWS partner providing cloud infrastructure and migration services",
      benefits: [
        "AWS certified architects",
        "Cloud migration expertise",
        "Infrastructure optimization",
        "24/7 cloud support"
      ],
      icon: Shield,
      color: "bg-orange-500",
      link: "/cloud-platforms"
    },
    {
      name: "MuleSoft Partner",
      description: "Certified MuleSoft partner delivering API-led integration and connectivity solutions",
      benefits: [
        "Certified MuleSoft architects",
        "API-led connectivity expertise",
        "Enterprise integration solutions",
        "CloudHub implementation"
      ],
      icon: Award,
      color: "bg-cyan-500",
      link: "/mulesoft"
    },
    {
      name: "Kinaxis Partner",
      description: "Kinaxis implementation partner for supply chain planning and optimization",
      benefits: [
        "Supply chain planning expertise",
        "RapidResponse implementation",
        "Demand & supply optimization",
        "S&OP solution delivery"
      ],
      icon: Shield,
      color: "bg-purple-500",
      link: "/kinaxis"
    }
  ];

  return (
    <section id="partnerships" className="py-12 md:py-16 lg:py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 bg-gradient-primary bg-clip-text text-transparent pb-2">
            Official Technology Partners
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            We're proud to be certified partners with leading technology providers, ensuring you get the best solutions and support for your business needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
          {partnerships.map((partnership, index) => (
            <Card key={index} className="bg-gradient-card border-0 shadow-card hover:shadow-elegant transition-all duration-300 hover:-translate-y-1 group">
              <CardContent className="p-6 md:p-8">
                <a href={partnership.link} className="block">
                  <div className="flex items-start gap-4 mb-6">
                    <div className={`${partnership.color} p-3 rounded-lg group-hover:scale-110 transition-transform duration-300`}>
                      <partnership.icon className="h-8 w-8 text-white" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {partnership.name}
                      </h3>
                      <p className="text-muted-foreground">
                        {partnership.description}
                      </p>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <h4 className="text-lg font-semibold text-foreground mb-3">Key Benefits:</h4>
                    {partnership.benefits.map((benefit, benefitIndex) => (
                      <div key={benefitIndex} className="flex items-center gap-3">
                        <CheckCircle className="h-5 w-5 text-primary flex-shrink-0" />
                        <span className="text-muted-foreground">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground">
            These partnerships enable us to deliver enterprise-grade solutions with the highest standards of quality and reliability.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partnerships;